export default {
  freeData: require('./freeData').default,
};
